{
	"approve": {
		"action": "Approve and publish",
		"after_list": "Students can report an error by {{time}} on {{day}}, then the ranking is final. The candidates receive an email with the address of the page.",
		"after_title": "What happens next",
		"blocked": "You cannot approve yet: {{conditions}}.",
		"cancel": "Cancel",
		"changed": "Version {{number}} of the ranking was made: we loaded it again. Check it and approve again.",
		"confirm": "Approve and publish version {{number}}",
		"errors": {
			"already": "The ranking is already approved.",
			"default": "We could not approve the ranking. Try again.",
			"not_approvable": "Some conditions are still missing: {{conditions}}."
		},
		"not_public_list": "Names, ISEEU, credits, who is not admitted and the excluded applications.",
		"not_public_title": "Does not become public",
		"public_list": "The three DSU lists: protocol, position, score and outcome. Who is only in the 70% list does not appear.",
		"public_title": "Becomes public",
		"success": "Ranking published.",
		"summary": "The public page opens at once.",
		"title": "Approve the ranking?"
	},
	"columns": {
		"name": "Surname and name",
		"notes": "Notes",
		"outcome": "Outcome",
		"position": "Pos.",
		"protocol": "Prot.",
		"score": "Score",
		"standing": "Counting application"
	},
	"conditions": {
		"all_met": "All the conditions to approve are met.",
		"applications_reviewed": "Every application is confirmed valid or has a problem reported",
		"calculation_done": "The calculation is done",
		"call_closed": "The call is closed",
		"flags_closed_or_expired": "The flags are closed or their term has run out",
		"flags_detail_missing_term": "{{count}} to close and the term is not fixed yet: the holidays are missing in the rules.",
		"flags_detail_open_one": "{{count}} flag to close, by 24:00 on {{day}}.",
		"flags_detail_open_other": "{{count}} flags to close, by 24:00 on {{day}}.",
		"intake_closed": "The intake of direct applications is closed",
		"met": "Met",
		"no_pending_recalculation": "No recalculation waiting: the ranking is up to date",
		"not_met": "Not yet",
		"recalculation_failing": "The recalculation did not go through and the system tries again every minute. If it does not clear, open a support request.",
		"recalculation_waiting": "Recalculation in progress since {{since}}: the ranking updates by itself, usually within a minute.",
		"review_detail_one": "{{count}} application to confirm.",
		"review_detail_other": "{{count}} applications to confirm.",
		"review_link": "Open the applications awaiting",
		"title": "Conditions to approve",
		"waits": "The ranking is calculated by itself when the conditions are there."
	},
	"control_lists": {
		"doctoral": "Doctoral and specialization",
		"excluded": "Excluded",
		"freshers": "First year",
		"later_years": "Later years",
		"not_admitted": "Not admitted",
		"q70": "70% quota list",
		"q70_dsu_seat": "70% quota with a DSU seat"
	},
	"details": {
		"title": "Calculation and versions"
	},
	"disability_priority_revoked": "Priority removed",
	"excluded": {
		"empty": "No excluded application.",
		"standing": "The application with protocol {{protocol}} stands",
		"subtitle": "The same person has another valid application: the last one sent counts."
	},
	"header": {
		"fingerprint": "Fingerprint",
		"line": "Version {{number}} · {{reason}} · computed on {{when}} · {{count}} valid applications",
		"rules": "Rules version",
		"version": "Version"
	},
	"late": "After the call",
	"lists": {
		"doctoral": {
			"subtitle": "Doctoral and specialization students entitled to the 30% quota, by score. With the later years they share the rest of the DSU seats, by score. It is public.",
			"title": "Doctoral and specialization students"
		},
		"empty": "No application in this list.",
		"freshers": {
			"subtitle": "First-year students entitled to the 30% quota, by score: 25% of the DSU seats, rounded up. It is public.",
			"title": "Matricole"
		},
		"later_years": {
			"subtitle": "Later-year students entitled to the 30% quota, by score. With the doctoral students they share the rest of the DSU seats, by score. It is public.",
			"title": "Later years"
		},
		"q70": {
			"subtitle": "Who may have a 70% seat: all three lists by score. It is not public.",
			"title": "70% quota list"
		},
		"q70_dsu_seat": {
			"subtitle": "Who is in the 70% quota list but already holds a DSU seat: they keep their position and take no seat of the 70% quota. Not public."
		},
		"seats_one": "{{count}} seat",
		"seats_other": "{{count}} seats",
		"shared_with": "shared with {{list}}",
		"unfilled_q30_one": "{{count}} DSU seat not taken in the whole 30% quota",
		"unfilled_q30_other": "{{count}} DSU seats not taken in the whole 30% quota",
		"unfilled_q70_one": "{{count}} seat not taken",
		"unfilled_q70_other": "{{count}} seats not taken"
	},
	"not_admitted": {
		"empty": "No application not admitted.",
		"missing_data": "Missing data",
		"quota": "{{quota}} quota",
		"reason": {
			"cfu_below_min": "credits below the minimum",
			"excluded_by_student": "quota excluded by the student",
			"iseeu_above": "ISEEU above the threshold",
			"ispeu_above": "ISPEU above the threshold",
			"missing_data": "missing data",
			"offsite_not_met": "off-site condition not met",
			"other": "requirement not met"
		}
	},
	"outcome": {
		"assigned": "Seat assigned · {{quota}} quota",
		"forfeited": "Forfeited",
		"no_seat": "In the ranking, with no seat",
		"withdrawn": "Withdrawn: accepted a place in another residence"
	},
	"page_switch": {
		"cancel": "Cancel",
		"confirm": "Disable the page",
		"description": "Use it only for a mistake of publication. The page says the ranking is temporarily unavailable, students cannot send reports and the versions already published stay in the file. When you enable it again, students have the whole 48 hours again.",
		"disable": "Disable the page",
		"disabled_done": "Page disabled.",
		"enable": "Enable the page again",
		"enabled": "Page enabled again.",
		"errors": {
			"disable": "We could not disable the page. Try again.",
			"enable": "We could not enable the page again. Check the ranking and try again."
		},
		"reason": "What mistake did you find?",
		"reason_hint": "The reason is recorded. At least {{min}} characters.",
		"reason_required": "Write at least {{min}} characters.",
		"since": "Disabled on {{when}}",
		"title": "Disable the public page?"
	},
	"page_title": "Ranking",
	"provisional_view": {
		"back": "Back to the calls",
		"banner": "Provisional ranking: declared data, not verified yet. It is not the ranking and can change until the call closes.",
		"closed": "The call is no longer open: the ranking of control stands.",
		"computed": "Calculated on {{when}}, each time the page is opened: it is not saved or published and students do not see it.",
		"empty": "No valid application yet.",
		"error": "We could not calculate the provisional ranking. Try again.",
		"open": "Provisional ranking"
	},
	"published": {
		"address": "Public page",
		"badge_disabled": "Page disabled",
		"badge_final": "Final",
		"badge_review": "Published",
		"copied": "Address copied.",
		"copy": "Copy the address",
		"disabled_title": "The public page is disabled",
		"final": "The ranking has been final since {{when}}",
		"review": "Students can report an error by {{time}} on {{day}}",
		"window_runs": "While the page is disabled the ranking does not become final. When you enable it again, reports reopen for the whole 48 hours."
	},
	"reason": {
		"assignment_forfeited": "Assignment forfeited",
		"disability_priority_restored": "Disability priority given back",
		"disability_priority_revoked": "Disability priority removed",
		"first_calculation": "First calculation",
		"flag_resolved": "Flag closed",
		"forfeit_annulled": "Correction of a material error",
		"late_application": "Application after the call",
		"ministry_authorization": "Authorization of the Ministry",
		"scrolling": "A place came free",
		"transcription_corrected": "Transcription corrected",
		"withdrawal_undone": "Application valid again"
	},
	"reports": {
		"link": "Errors reported by students"
	},
	"rules_note": "The lists and the score follow the DiSCo rules of the call, section 5: three DSU lists ordered by score, 25% of the DSU seats to the matricole and the rest to later years and doctoral students together.",
	"seat_origin": {
		"equipped_priority": "Place with disability priority",
		"ministry_authorization": "DSU seat authorized by the Ministry",
		"other_list": "DSU seat the other group left free"
	},
	"state": {},
	"verifying": "Judged on the declared data",
	"versions": {
		"published": "Published",
		"title": "Versions",
		"unpublished": "Not published"
	}
}
